import AssetsManager from '../../../data/AssetsManager'

/**
 * PlayerViewクラス
 */
class PlayerView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	BtnView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super()

    //ミスした時の色の演出
    this.missColors = [0xFFFFFF, 0xffff00, 0xfe050b, 0x0071dd]

    //ノーマルプレイヤー
    this.player = AssetsManager.createMovieClipFromAnimation('player')
    this.player.anchor.set(0.5, 0.0)
    this.addChild(this.player)

    //歩く
    this.walkPlayer = AssetsManager.createMovieClipFromAnimation('player_walk')
    this.walkPlayer.anchor.set(0.5, 0.0)
    this.walkPlayer.animationSpeed = 0.2
    this.walkPlayer.play()
    this.addChild(this.walkPlayer)

    //リセット
    this.reset()
  }

  reset()
  {
    //色を戻す
    this.player.tint = 0xFFFFFF
    this.walkPlayer.tint = 0xFFFFFF

    //ミスの演出停止
    this.missCount = -1
    if(this.missTimer)
    {
      this.missTimer.kill()
      this.missTimer = null
    }

    //位置初期化
    this.x = 0
    this.y = -26

    //表示
    this.player.gotoAndStop(0)
    this.walkPlayer.visible = false
  }

  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 表示
  // --------------------------------------------------------------------------------------------------------------------------------------

  pushLeftBtn()
  {
    this.player.gotoAndStop(1)
    this.player.visible = true
    this.walkPlayer.visible = false
  }

  pushRightBtn()
  {
    this.player.gotoAndStop(2)
    this.player.visible = true
    this.walkPlayer.visible = false
  }

  stay()
  {
    this.player.gotoAndStop(0)
    this.player.visible = true
    this.walkPlayer.visible = false
  }

  walk()
  {
    this.player.visible = false
    this.walkPlayer.visible = true
  }

  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 ミスした時の演出
  // --------------------------------------------------------------------------------------------------------------------------------------

  miss()
  {
    this.missCount = 0
    this.missAnimation()
  }

  missAnimation()
  {
    this.missCount ++
    const color = this.missColors[this.missCount%4]
    this.player.tint = color
    this.walkPlayer.tint = color

    if(this.missCount <= 20)
    {
      this.missTimer = gsap.delayedCall(0.02, ()=>{
        this.missAnimation()
      })
    }
    else
    {
      this.missTimer = null
      this.player.tint = 0xFFFFFF
      this.walkPlayer.tint = 0xFFFFFF
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default PlayerView
